import { gql } from '@apollo/client';

export default gql`
  mutation requestPrimaryUser($input: requestPrimaryUserInput!) {
    requestPrimaryUser(input: $input) {
      MessageId
    }
  }
`;
